import { vtexConstants } from '@constants/vtex';

const initialState = {
    data: [],
    loading: true,
    error: '',
};

export function vtex(state = initialState, action) {
    switch (action.type) {
        case vtexConstants.VTEX_ACCOUNTS_REQUEST:
            return { ...state, loading: true, error: '' };
        case vtexConstants.VTEX_ACCOUNTS_SUCCESS:
            return { ...state, loading: false, data: [action.data] };
        case vtexConstants.VTEX_ACCOUNTS_ERROR:
            return { ...state, loading: false, error: action.message };
        case vtexConstants.VTEX_ACCOUNTS_RESET:
            return { ...state, data: [] };
        default:
            return state;
    }
}
